import { render, staticRenderFns } from "./inTransit.vue?vue&type=template&id=47c682e0&scoped=true"
import script from "./inTransit.vue?vue&type=script&lang=js"
export * from "./inTransit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c682e0",
  null
  
)

export default component.exports